import React, { FC } from 'react';

export const YoutubeIcon: FC<{ className?: string; href?: string }> = (props) => {
  return (
    <a className={props.className} href={props.href}>
      <svg width="18" height="12" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.687 6.55l-4.89 2.919C6.282 9.776 6 9.527 6 8.917V3.086c0-.61.273-.86.788-.556l4.897 2.907c.515.304.313.872.002 1.113M15 0H3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3"
          fill="#BEBEBE"
          fillRule="evenodd"
        ></path>
      </svg>
    </a>
  );
};
